export const simpleCardPassthrough = {
  root: {
    class:
      'max-w-[343px] max-tablet:max-w-full border-solid border rounded-lg border-cool-gray-200 bg-white p-[16px]',
  },
  body: {
    class: 'flex justify-between items-center gap-x-[8px]',
  },
  caption: {
    class: 'flex flex-col gap-y-[4px] justify-center truncate',
  },
  title: {
    class: 'text-sm',
  },
  subtitle: {
    class: 'text-base leading-5 font-semibold truncate',
  },
  content: {
    class: 'hidden',
  },
}

export const specialCardPassThrough = {
  root: {
    class:
      'max-w-[343px] max-tablet:max-w-full border-solid border rounded-lg border-cool-gray-200 bg-white mb-2xs h-fit',
  },
  caption: {
    class: 'p-xs',
  },
  header: {
    class:
      'text-lg leading-tight font-medium bg-gray rounded-t-lg p-xs mb-xs flex items-center flex-wrap whitespace-pre-wrap justify-between',
  },
  content: {
    class: 'flex flex-col justify-between gap-xs m-xs',
  },
}

export const formCardPassThrough = {
  root: {
    class:
      'max-w-[343px] max-tablet:max-w-full border-solid border rounded-lg border-cool-gray-200 bg-white mb-2xs h-fit relative',
  },
  caption: {
    class: 'p-xs',
  },
  header: {
    class:
      'text-lg leading-tight font-medium bg-gray rounded-t-lg p-xs mb-xs flex items-center flex-wrap whitespace-pre-wrap justify-between',
  },
  content: {
    class: 'flex flex-col justify-between',
  },
}
